import React, { useMemo } from 'react';
import classNames from 'classnames';
import { LEAD_STAGES } from 'models/Lead';
import { LeadStagesCopies } from 'models/DealRoom';
import useLeadStagesCopy from 'hooks/useLeadStagesCopy';

import './PortfolioStage.styles.scss';
import './PortfolioStage.styles.responsive.scss';

type PortfolioStageProps = {
  className?: string;
  asBuyer: boolean;
  progressedStep: number;
  leadProgressedStep?: number;
  numberOfEnquiredLeads: number;
  numberOfAcceptedLeads: number;
  numberOfConfirmedLeads: number;
  numberOfOfferedLeads: number;
  leadStagesCopies: LeadStagesCopies;
};

const PortfolioStage: React.FC<PortfolioStageProps> = (props) => {
  const {
    className,
    asBuyer,
    progressedStep,
    leadProgressedStep,
    numberOfEnquiredLeads,
    numberOfAcceptedLeads,
    numberOfConfirmedLeads,
    numberOfOfferedLeads,
    leadStagesCopies,
  } = props;

  const copies = useLeadStagesCopy().getCopies(leadStagesCopies);

  const classes = classNames('portfolio-stage', className);

  const STEPS = useMemo(
    () => ({
      [LEAD_STAGES.ENQUIRE]: {
        label: copies[LEAD_STAGES.ENQUIRE],
        number: numberOfEnquiredLeads,
      },
      [LEAD_STAGES.ACCEPT]: {
        label: copies[LEAD_STAGES.ACCEPT],
        number: numberOfAcceptedLeads,
      },
      [LEAD_STAGES.CONFIRM]: {
        label: copies[LEAD_STAGES.CONFIRM],
        number: numberOfConfirmedLeads,
      },
      [LEAD_STAGES.OFFER]: {
        label: copies[LEAD_STAGES.OFFER],
        number: numberOfOfferedLeads,
      },
    }),
    [
      copies,
      numberOfAcceptedLeads,
      numberOfConfirmedLeads,
      numberOfEnquiredLeads,
      numberOfOfferedLeads,
    ],
  );

  const renderSteps = useMemo(() => {
    const steps = Object.values(STEPS);
    return steps.map(({ label, number }, index) => {
      const fill = asBuyer
        ? index <= leadProgressedStep
        : index === 0 && progressedStep === 0 && !numberOfEnquiredLeads
        ? false
        : index <= progressedStep;

      return (
        <div key={label} className={classNames({ fill })}>
          <div className="circle" />
          {label} {!asBuyer && <span>({number})</span>}
          <div className="line" />
        </div>
      );
    });
  }, [
    STEPS,
    asBuyer,
    leadProgressedStep,
    numberOfEnquiredLeads,
    progressedStep,
  ]);

  return <div className={classes}>{renderSteps}</div>;
};

export default PortfolioStage;
